/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../bbcategoriescommon/frontend/frontend';
import '../bankingfindata/transaction';
import '../connect/v2/common/money';
import '../banking/common';
import '../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "balancereporter": {
        "nested": {
          "BalanceReportItemStateCategory": {
            "values": {
              "DO_NOT_USE_STATE_CATEGORY": 0,
              "PENDING": 1,
              "COMPLETED": 2
            }
          },
          "BalanceReportItemTypeCategory": {
            "values": {
              "DO_NOT_USE_TYPE_CATEGORY": 0,
              "PAYMENT_PROCESSING": 1,
              "CARD_SPEND": 2,
              "TRANSFERS": 3
            }
          },
          "BalanceReportItemActivityType": {
            "values": {
              "ACH_RETURN": 1,
              "ACH_TRANSFER_IN": 2,
              "ACH_TRANSFER_OUT": 3,
              "ADJUSTED_DIRECT_DEPOSIT_IN": 64,
              "ADJUSTED_DIRECT_DEPOSIT_IN_CHARGEBACK": 67,
              "ADMIN_ADJUSTMENT": 4,
              "ATM_WITHDRAWAL": 5,
              "AUTOMATIC_SAVINGS_TRANSFER": 6,
              "BACKUP_WITHHOLDING": 7,
              "BALANCE_TRANSFER_IN_SFS_TO_BANKLIN": 8,
              "BALANCE_TRANSFER_OTHER": 9,
              "BALANCE_TRANSFER_OUT_BANKLIN_TO_SFS": 10,
              "BILL_PAYMENT": 11,
              "BITCOIN_SAVINGS_TRANSFER": 12,
              "CAPITAL_LOAN": 13,
              "CAPITAL_LOAN_CANCELLATION": 14,
              "CAPITAL_LOAN_PAYMENT": 70,
              "CAPITAL_LOAN_PAYMENT_REFUND": 71,
              "CAPTURE": 15,
              "CARD_PAYMENT": 16,
              "CARD_PROCESSING_ADJUSTMENTS": 17,
              "CARD_PROCESSING_SALES": 18,
              "CHECK_TRANSFER_IN": 19,
              "CHECK_TRANSFER_OUT": 58,
              "CHECK_TRANSFER_IN_CHARGEBACK": 20,
              "COST_PLUS_FEE": 21,
              "CREDIT_CARD_WITHHOLDING": 22,
              "DEBIT_CARD_PAY_IN_CHARGEBACK": 23,
              "DEBIT_CARD_TRANSFER_IN": 24,
              "DIRECT_DEPOSIT_IN": 25,
              "DIRECT_DEPOSIT_IN_CHARGEBACK": 26,
              "DIRECT_DEPOSIT_OUT": 27,
              "DISCREPANCY_ADJUSTMENTS": 73,
              "DISPUTE_ADJUSTMENT": 28,
              "ESCHEATMENT_ADJUSTMENT": 29,
              "FOLDER_AUTOMATED_SAVINGS": 61,
              "FREE_PROCESSING_ADJUSTMENT": 30,
              "GIFT_CARD_FUND_POOLING": 62,
              "GIFT_CARD_LOAD_FEE": 72,
              "HOLD": 31,
              "INSTANT_TRANSFER_OUT": 32,
              "INTEREST": 33,
              "INTERNAL_MONEY_MOVEMENT": 34,
              "INTER_BALANCE_TRANSFER_IN": 59,
              "INTER_BALANCE_TRANSFER_OUT": 60,
              "LEDGER_ADJUSTMENT": 35,
              "LOCAL_OFFERS_CASHBACK": 65,
              "LOCAL_OFFERS_FEE": 66,
              "MCA_REPAYMENT": 36,
              "MCA_REPAYMENT_REFUND": 37,
              "OPEN_DISPUTE": 38,
              "OTHER": 39,
              "PAPER_CASH_DEPOSIT_CHARGEBACK": 69,
              "PAPER_CASH_DEPOSIT_IN": 68,
              "PAYROLL": 40,
              "PAYROLL_CANCELLATION": 41,
              "PREFUNDED_ORDER": 63,
              "PROCESSING_FEE": 42,
              "PROMOTIONAL_REWARD": 43,
              "REFUND": 44,
              "RELEASE": 45,
              "REPORTING_ADJUSTMENT": 46,
              "RESOLVED_DISPUTE": 47,
              "RISK_RESERVE_HOLD": 48,
              "RISK_RESOLVE_RELEASE": 49,
              "SAVINGS_FOLDER_TRANSFER_IN": 50,
              "SAVINGS_FOLDER_TRANSFER_OUT": 51,
              "STANDARD_SPEED_TRANSFER_OUT": 52,
              "THIRD_PARTY_FEE": 53,
              "THIRD_PARTY_FEE_REFUND": 54,
              "UNDO": 55,
              "UNDO_HOLD": 56,
              "UNDO_RELEASE": 57
            }
          },
          "BalanceReportItemState": {
            "values": {
              "DO_NOT_USE_STATE": 0,
              "SETTLED": 1,
              "VOIDED": 2,
              "DECLINED": 3,
              "REFUNDED": 4,
              "REVERSED": 5,
              "DISPUTED": 6,
              "DISPUTE_REVERSED": 7,
              "DISPUTE_WON": 8,
              "IN_REVIEW": 9,
              "IN_REVERSAL": 10,
              "WAITING_ON_EXTERNAL": 11,
              "INITIATED": 12,
              "PENDING_STATE": 13,
              "DISPUTE_WRITTEN_OFF": 14
            }
          },
          "BalanceOverviewType": {
            "values": {
              "DO_NOT_USE_OVERVIEW_TYPE": 0,
              "CHECKING_BALANCE_OVERVIEW": 1,
              "CHECKING_BALANCE_OVERVIEW_NO_PROCESSING_SUBLINES": 2
            }
          },
          "BalanceReportItemType": {
            "values": {
              "BALANCE_REPORT_ITEM_TYPE_DO_NOT_USE": 0,
              "GENERIC": 1,
              "BALANCE_REPORT_ITEM_TYPE_PRINTABLE_CHECK": 2
            }
          },
          "ExpenseCategoryType": {
            "values": {
              "PERSONAL": 0,
              "BUSINESS": 1
            }
          },
          "BalanceReportItemDetail": {
            "fields": {
              "latestEventAt": {
                "type": "squareup.common.time.DateTime",
                "id": 1,
                "rule": "optional"
              },
              "lineItems": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem",
                "id": 2,
                "rule": "repeated"
              },
              "pillDetail": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.PillDetail",
                "id": 3,
                "rule": "optional"
              },
              "footer": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.Footer",
                "id": 4,
                "rule": "optional"
              },
              "balanceReportItem": {
                "type": "squareup.balancereporter.BalanceReportItem",
                "id": 5,
                "rule": "optional"
              },
              "disputeStatus": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.DisputeStatus",
                "id": 6,
                "rule": "optional"
              },
              "attachments": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailAttachment",
                "id": 7,
                "rule": "repeated"
              },
              "banner": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.Banner",
                "id": 8,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "findataTransactionInfo": {
                "type": "squareup.balancereporter.BalanceReportItemDetail.FindataTransactionInfo",
                "id": 10,
                "rule": "optional"
              }
            },
            "nested": {
              "BalanceReportItemDetailLineItem": {
                "fields": {
                  "description": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Description",
                    "id": 1
                  },
                  "expenseType": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.ExpenseType",
                    "id": 2
                  },
                  "timestamp": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp",
                    "id": 3
                  },
                  "categoryData": {
                    "type": "squareup.bbcategoriescommon.frontend.ActivityItemDetailLineItem.CategoryData",
                    "id": 4
                  }
                },
                "nested": {
                  "Tooltip": {
                    "fields": {
                      "trigger": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.Icon",
                        "id": 1,
                        "rule": "optional"
                      },
                      "text": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "textLinks": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.TextLink",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "Icon": {
                        "values": {
                          "DO_NOT_USE_ICON": 0,
                          "INFO": 1
                        }
                      },
                      "TextLink": {
                        "fields": {
                          "label": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "Description": {
                    "fields": {
                      "translatedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "translatedValue": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "tooltip": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ExpenseType": {
                    "fields": {
                      "translatedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isPersonalExpense": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      },
                      "category": {
                        "type": "squareup.balancereporter.ExpenseCategoryType",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "Timestamp": {
                    "fields": {
                      "translatedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "timestamp": {
                        "type": "squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "displayFormat": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp.DisplayFormat",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DisplayFormat": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "TIME": 1,
                          "DATE": 2,
                          "DATE_AND_TIME": 3
                        }
                      }
                    }
                  },
                  "line_item": {
                    "oneof": ["description", "expenseType", "timestamp", "categoryData"]
                  }
                }
              },
              "PillDetail": {
                "fields": {
                  "translatedLabel": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "Footer": {
                "fields": {
                  "footer": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "footerLinks": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Footer.FooterLink",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buttonAction": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Footer.ButtonAction",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FooterLink": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ButtonAction": {
                    "fields": {
                      "redirectToTransactions": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.Footer.ButtonAction.RedirectToTransactions",
                        "id": 1
                      }
                    },
                    "nested": {
                      "RedirectToTransactions": {
                        "fields": {
                          "buttonText": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "action": {
                        "oneof": ["redirectToTransactions"]
                      }
                    }
                  }
                }
              },
              "DisputeStatus": {
                "values": {
                  "DO_NOT_USE": 0,
                  "INVALID": 1,
                  "DISPUTABLE": 2,
                  "CURRENTLY_DISPUTED": 3
                }
              },
              "BalanceReportItemDetailAttachment": {
                "fields": {
                  "checkImage": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailAttachment.CheckImage",
                    "id": 1
                  }
                },
                "nested": {
                  "CheckImage": {
                    "fields": {
                      "translatedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "imageData": {
                        "type": "bytes",
                        "id": 2,
                        "rule": "optional"
                      },
                      "checkToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "transferToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "content": {
                    "oneof": ["checkImage"]
                  }
                }
              },
              "Banner": {
                "fields": {
                  "customizedIcon": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.Icon",
                    "id": 1,
                    "rule": "optional"
                  },
                  "variant": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.Variant",
                    "id": 2,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "primaryAction": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.Action",
                    "id": 5,
                    "rule": "optional"
                  },
                  "secondaryAction": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.Action",
                    "id": 6,
                    "rule": "optional"
                  },
                  "displayPosition": {
                    "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.DisplayPosition",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": "TOP"
                    }
                  }
                },
                "nested": {
                  "Icon": {
                    "values": {
                      "DO_NOT_USE_ICON": 0,
                      "DASHED_CIRCLE_STAR": 1,
                      "LIGHTNING_BOLT": 2
                    }
                  },
                  "Variant": {
                    "values": {
                      "DO_NOT_USE_VARIANT": 0,
                      "INFO": 1,
                      "SUCCESS": 2,
                      "WARNING": 3,
                      "CRITICAL": 4,
                      "INSIGHT": 5
                    }
                  },
                  "ExternalLink": {
                    "fields": {
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Action": {
                    "fields": {
                      "label": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "externalLink": {
                        "type": "squareup.balancereporter.BalanceReportItemDetail.Banner.ExternalLink",
                        "id": 2
                      }
                    },
                    "nested": {
                      "action": {
                        "oneof": ["externalLink"]
                      }
                    }
                  },
                  "DisplayPosition": {
                    "values": {
                      "DO_NOT_USE_DISPLAY_POSITION": 0,
                      "TOP": 1,
                      "BOTTOM": 2
                    }
                  }
                }
              },
              "FindataTransactionInfo": {
                "fields": {
                  "accountIdentifier": {
                    "type": "squareup.bankingfindata.transaction.AccountUniqueIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "findataTransactionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "findataAccountIdentifier": {
                    "type": "bytes",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "BalanceReportItemImage": {
            "fields": {
              "imageUrl": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "colorCode": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "backgroundColorCode": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "isPrerendered": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "decorationIcon": {
                "type": "squareup.balancereporter.BalanceReportItemImage.DecorationIcon",
                "id": 5,
                "rule": "optional"
              }
            },
            "nested": {
              "DecorationIcon": {
                "fields": {
                  "icon": {
                    "type": "squareup.balancereporter.BalanceReportItemImage.DecorationIcon.Icon",
                    "id": 1,
                    "rule": "optional"
                  },
                  "backgroundColorCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Icon": {
                    "values": {
                      "DO_NOT_USE_ICON": 0,
                      "LIGHTNING_BOLT": 1
                    }
                  }
                }
              }
            }
          },
          "BalanceReportItemCanonicalCategory": {
            "fields": {
              "name": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "imageUrl": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "BalanceReportItem": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "latestEventAt": {
                "type": "squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "state": {
                "type": "squareup.balancereporter.BalanceReportItemState",
                "id": 3,
                "rule": "optional"
              },
              "stateCategory": {
                "type": "squareup.balancereporter.BalanceReportItemStateCategory",
                "id": 4,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.balancereporter.BalanceReportItemType",
                "id": 5,
                "rule": "optional"
              },
              "typeCategory": {
                "type": "squareup.balancereporter.BalanceReportItemTypeCategory",
                "id": 6,
                "rule": "optional"
              },
              "title": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "amount": {
                "type": "squareup.connect.v2.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "balance": {
                "type": "squareup.connect.v2.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "image": {
                "type": "squareup.balancereporter.BalanceReportItemImage",
                "id": 11,
                "rule": "optional"
              },
              "transactionId": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "owner": {
                "type": "squareup.banking.Owner",
                "id": 13,
                "rule": "optional"
              },
              "canonicalCategory": {
                "type": "squareup.balancereporter.BalanceReportItemCanonicalCategory",
                "id": 14,
                "rule": "optional"
              },
              "transactionReasonCode": {
                "type": "string",
                "id": 15,
                "rule": "optional"
              },
              "bankcBalanceId": {
                "type": "string",
                "id": 16,
                "rule": "optional"
              },
              "activityType": {
                "type": "squareup.balancereporter.BalanceReportItemActivityType",
                "id": 17,
                "rule": "optional"
              },
              "firstEventAt": {
                "type": "squareup.common.time.DateTime",
                "id": 18,
                "rule": "optional"
              },
              "sortKey": {
                "type": "string",
                "id": 20,
                "rule": "optional"
              },
              "transactionCategoryName": {
                "type": "string",
                "id": 21,
                "rule": "optional"
              },
              "amountDetails": {
                "type": "squareup.balancereporter.AmountDetails",
                "id": 22,
                "rule": "optional"
              },
              "reportTypeMetadata": {
                "type": "squareup.balancereporter.ReportTypeMetadata",
                "id": 23,
                "rule": "optional"
              },
              "declineDetails": {
                "type": "squareup.balancereporter.BalanceReportItem.DeclineDetails",
                "id": 19
              }
            },
            "nested": {
              "DeclineDetails": {
                "fields": {
                  "declineReason": {
                    "type": "squareup.balancereporter.BalanceReportItem.DeclineDetails.DeclineReason",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DeclineReason": {
                    "values": {
                      "DECLINE_REASON_UNKNOWN": 0,
                      "OVER_LIMIT": 1,
                      "INSUFFICIENT_FUNDS": 2,
                      "UNACTIVATED_INSTRUMENT": 3,
                      "INSTRUMENT_DISABLED": 4,
                      "ACCOUNT_FROZEN": 5,
                      "UNSUPPORTED_COUNTRY": 6,
                      "UNSUPPORTED_CURRENCY": 7,
                      "INVALID_CVV": 8,
                      "INVALID_AVS": 9,
                      "INVALID_PIN": 10,
                      "GENERIC_FAILURE": 11,
                      "SUSPECTED_FRAUD": 12,
                      "MERCHANT_BLOCKED_BY_CUSTOMER": 13,
                      "MERCHANT_BLOCKED_FOR_SPONSORED_CUSTOMER": 14,
                      "CARD_TERMINATED": 15,
                      "PIN_TRY_LIMIT_EXCEEDED": 16,
                      "IN_APP_AUTHENTICATION_REQUIRED": 17
                    }
                  }
                }
              },
              "state_details": {
                "oneof": ["declineDetails"]
              }
            }
          },
          "BalanceOverviewLineItem": {
            "fields": {
              "lineItemType": {
                "type": "squareup.balancereporter.BalanceOverviewLineItem.BalanceOverviewLineItemType",
                "id": 1,
                "rule": "optional"
              },
              "total": {
                "type": "squareup.connect.v2.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "translatedLabel": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "BalanceOverviewLineItemType": {
                "values": {
                  "UNKNOWN": 0,
                  "PROCESSING_CARD_PAYMENTS": 1,
                  "PROCESSING_CARD_REFUNDS": 2,
                  "PROCESSING_CARD_TOTAL_COLLECTED": 3,
                  "PROCESSING_CARD_FEES": 4,
                  "PROCESSING_FREE_PROCESSING_CREDIT": 5,
                  "PROCESSING_SQUARE_CAPITAL_REPAYMENT": 6,
                  "PROCESSING_DISPUTES": 7,
                  "PROCESSING_RESERVES_HELD": 8,
                  "PROCESSING_RESERVES_RELEASED": 9,
                  "PROCESSING_OTHER_ADJUSTMENTS": 10,
                  "CARD_PAYMENT": 11,
                  "ATM_WITHDRAWAL": 12,
                  "PROMOTIONAL_REWARD": 13,
                  "TRANSFERS_OUT": 14,
                  "TRANSFERS_INSTANT_FEES": 15,
                  "TRANSFERS_IN": 16,
                  "PROCESSING_BANK_ACCOUNT_DEBITS": 17,
                  "PROCESSING_SAVINGS_TRANSFER": 18,
                  "PROCESSING_BITCOIN_SAVINGS": 19,
                  "PROCESSING_BANKING_FOLDERS": 20,
                  "PROCESSING_GIFT_CARD_FUND_POOLING": 21,
                  "PROCESSING_LOCAL_OFFERS_CASHBACK": 22,
                  "PROCESSING_LOCAL_OFFERS_FEE": 23,
                  "DOORDASH_ORDERS": 24,
                  "UBER_EATS_ORDERS": 25,
                  "PROCESSING_GIFT_CARD_LOAD_FEE": 26
                }
              }
            }
          },
          "BalanceOverviewTopLevelLineItem": {
            "fields": {
              "lineItemType": {
                "type": "squareup.balancereporter.BalanceOverviewTopLevelLineItem.BalanceOverviewTopLevelLineItemType",
                "id": 1,
                "rule": "optional"
              },
              "total": {
                "type": "squareup.connect.v2.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "subLineItems": {
                "type": "squareup.balancereporter.BalanceOverviewLineItem",
                "id": 3,
                "rule": "repeated"
              },
              "translatedLabel": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              }
            },
            "nested": {
              "BalanceOverviewTopLevelLineItemType": {
                "values": {
                  "UNKNOWN": 0,
                  "PAYMENT_PROCESSING": 1,
                  "SQUARE_CARD_SPEND": 2,
                  "TRANSFERS": 3,
                  "PAYROLL": 4,
                  "LOANS": 5,
                  "BILL_PAYMENTS": 6,
                  "PREFUNDED_ORDERS": 7
                }
              }
            }
          },
          "BalanceOverview": {
            "fields": {
              "startingBalance": {
                "type": "squareup.connect.v2.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "endingBalance": {
                "type": "squareup.connect.v2.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "lineItems": {
                "type": "squareup.balancereporter.BalanceOverviewTopLevelLineItem",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "ReportType": {
            "values": {
              "UNKNOWN": 0,
              "SQUARE_CARD_UNIT": 1,
              "SFS_BANKC_BALANCE": 2,
              "SFS_MERCHANT": 3,
              "BANKING_FOLDER": 4,
              "SQUARE_CARD_BALANCE": 5
            }
          },
          "ReportAccountId": {
            "fields": {
              "reportType": {
                "type": "squareup.balancereporter.ReportType",
                "id": 1,
                "rule": "optional"
              },
              "id": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "CurrencyConversionData": {
            "fields": {
              "originalCurrencyAmount": {
                "type": "squareup.connect.v2.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "currencyConversionRate": {
                "type": "double",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "AmountDetails": {
            "fields": {
              "currencyConversionData": {
                "type": "squareup.balancereporter.CurrencyConversionData",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "ReportTypeMetadata": {
            "fields": {
              "squareCardMetadata": {
                "type": "squareup.balancereporter.ReportTypeMetadata.SquareCardMetadata",
                "id": 1
              }
            },
            "nested": {
              "SquareCardMetadata": {
                "fields": {
                  "cardSpendMerchant": {
                    "type": "squareup.balancereporter.ReportTypeMetadata.SquareCardMetadata.CardSpendMerchant",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CardSpendMerchant": {
                    "fields": {
                      "merchantAddress": {
                        "type": "squareup.common.location.GlobalAddress",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchanteinMerchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "report_type_metadata": {
                "oneof": ["squareCardMetadata"]
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemStateCategory && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemTypeCategory && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemActivityType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemState && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverviewType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ExpenseCategoryType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Tooltip && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Tooltip?.nested?.Icon && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Tooltip?.nested?.TextLink && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Description && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.ExpenseType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Timestamp && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailLineItem?.nested?.Timestamp?.nested?.DisplayFormat && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.PillDetail && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Footer && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Footer?.nested?.FooterLink && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Footer?.nested?.ButtonAction && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Footer?.nested?.ButtonAction?.nested?.RedirectToTransactions && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.DisputeStatus && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailAttachment && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.BalanceReportItemDetailAttachment?.nested?.CheckImage && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner?.nested?.Icon && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner?.nested?.Variant && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner?.nested?.ExternalLink && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner?.nested?.Action && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.Banner?.nested?.DisplayPosition && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemDetail?.nested?.FindataTransactionInfo && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemImage && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemImage?.nested?.DecorationIcon && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemImage?.nested?.DecorationIcon?.nested?.Icon && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItemCanonicalCategory && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItem && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItem?.nested?.DeclineDetails && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceReportItem?.nested?.DeclineDetails?.nested?.DeclineReason && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverviewLineItem && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverviewLineItem?.nested?.BalanceOverviewLineItemType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverviewTopLevelLineItem && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverviewTopLevelLineItem?.nested?.BalanceOverviewTopLevelLineItemType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.BalanceOverview && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ReportType && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ReportAccountId && !$root.nested?.squareup?.nested?.balancereporter?.nested?.CurrencyConversionData && !$root.nested?.squareup?.nested?.balancereporter?.nested?.AmountDetails && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ReportTypeMetadata && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ReportTypeMetadata?.nested?.SquareCardMetadata && !$root.nested?.squareup?.nested?.balancereporter?.nested?.ReportTypeMetadata?.nested?.SquareCardMetadata?.nested?.CardSpendMerchant) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BalanceReportItemStateCategory @ squareup/balancereporter/model.proto at 17:1
 */
export const BalanceReportItemStateCategory = $root.lookupEnum('squareup.balancereporter.BalanceReportItemStateCategory').values;
/**
 * SOURCE BalanceReportItemTypeCategory @ squareup/balancereporter/model.proto at 25:1
 */
export const BalanceReportItemTypeCategory = $root.lookupEnum('squareup.balancereporter.BalanceReportItemTypeCategory').values;
/**
 * SOURCE BalanceReportItemActivityType @ squareup/balancereporter/model.proto at 32:1
 */
export const BalanceReportItemActivityType = $root.lookupEnum('squareup.balancereporter.BalanceReportItemActivityType').values;
/**
 * SOURCE BalanceReportItemState @ squareup/balancereporter/model.proto at 111:1
 */
export const BalanceReportItemState = $root.lookupEnum('squareup.balancereporter.BalanceReportItemState').values;
/**
 * SOURCE BalanceOverviewType @ squareup/balancereporter/model.proto at 129:1
 */
export const BalanceOverviewType = $root.lookupEnum('squareup.balancereporter.BalanceOverviewType').values;
/**
 * SOURCE BalanceReportItemType @ squareup/balancereporter/model.proto at 156:1
 */
export const BalanceReportItemType = $root.lookupEnum('squareup.balancereporter.BalanceReportItemType').values;
/**
 * SOURCE ExpenseCategoryType @ squareup/balancereporter/model.proto at 166:1
 */
export const ExpenseCategoryType = $root.lookupEnum('squareup.balancereporter.ExpenseCategoryType').values;
/**
 * SOURCE BalanceReportItemDetail @ squareup/balancereporter/model.proto at 184:1
 */
export const BalanceReportItemDetail = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail');
fixType(BalanceReportItemDetail, {
  latestEventAt: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail);
/**
 * SOURCE BalanceReportItemDetailLineItem @ squareup/balancereporter/model.proto at 185:3
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem);
/**
 * A Market tooltip that highlights additional info about this balance report item detail line item
 *
 * SOURCE Tooltip @ squareup/balancereporter/model.proto at 187:5
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip);
/**
 * SOURCE Icon @ squareup/balancereporter/model.proto at 188:7
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.Icon = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.Icon').values;
/**
 * SOURCE TextLink @ squareup/balancereporter/model.proto at 196:7
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.TextLink = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.TextLink');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.TextLink);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Tooltip.TextLink);
/**
 * SOURCE Description @ squareup/balancereporter/model.proto at 204:5
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Description = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Description');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Description);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Description);
/**
 * SOURCE ExpenseType @ squareup/balancereporter/model.proto at 210:5
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.ExpenseType = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.ExpenseType');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.ExpenseType);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.ExpenseType);
/**
 * SOURCE Timestamp @ squareup/balancereporter/model.proto at 216:5
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp');
fixType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp);
/**
 * SOURCE DisplayFormat @ squareup/balancereporter/model.proto at 217:7
 */
BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp.DisplayFormat = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailLineItem.Timestamp.DisplayFormat').values;
/**
 * SOURCE PillDetail @ squareup/balancereporter/model.proto at 238:3
 */
BalanceReportItemDetail.PillDetail = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.PillDetail');
fixType(BalanceReportItemDetail.PillDetail, {
  translatedLabel: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail.PillDetail);
/**
 * SOURCE Footer @ squareup/balancereporter/model.proto at 251:3
 */
BalanceReportItemDetail.Footer = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Footer');
fixType(BalanceReportItemDetail.Footer);
Builder.createAndAttachToType(BalanceReportItemDetail.Footer);
/**
 * SOURCE FooterLink @ squareup/balancereporter/model.proto at 258:5
 */
BalanceReportItemDetail.Footer.FooterLink = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Footer.FooterLink');
fixType(BalanceReportItemDetail.Footer.FooterLink);
Builder.createAndAttachToType(BalanceReportItemDetail.Footer.FooterLink);
/**
 * SOURCE ButtonAction @ squareup/balancereporter/model.proto at 266:5
 */
BalanceReportItemDetail.Footer.ButtonAction = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Footer.ButtonAction');
fixType(BalanceReportItemDetail.Footer.ButtonAction);
Builder.createAndAttachToType(BalanceReportItemDetail.Footer.ButtonAction);
/**
 * SOURCE RedirectToTransactions @ squareup/balancereporter/model.proto at 267:7
 */
BalanceReportItemDetail.Footer.ButtonAction.RedirectToTransactions = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Footer.ButtonAction.RedirectToTransactions');
fixType(BalanceReportItemDetail.Footer.ButtonAction.RedirectToTransactions);
Builder.createAndAttachToType(BalanceReportItemDetail.Footer.ButtonAction.RedirectToTransactions);
/**
 * SOURCE DisputeStatus @ squareup/balancereporter/model.proto at 284:3
 */
BalanceReportItemDetail.DisputeStatus = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.DisputeStatus').values;
/**
 * SOURCE BalanceReportItemDetailAttachment @ squareup/balancereporter/model.proto at 294:3
 */
BalanceReportItemDetail.BalanceReportItemDetailAttachment = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailAttachment');
fixType(BalanceReportItemDetail.BalanceReportItemDetailAttachment);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailAttachment);
/**
 * Check Image Type Attachment
 *
 * SOURCE CheckImage @ squareup/balancereporter/model.proto at 296:5
 */
BalanceReportItemDetail.BalanceReportItemDetailAttachment.CheckImage = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.BalanceReportItemDetailAttachment.CheckImage');
fixType(BalanceReportItemDetail.BalanceReportItemDetailAttachment.CheckImage);
Builder.createAndAttachToType(BalanceReportItemDetail.BalanceReportItemDetailAttachment.CheckImage);
/**
 * A Market banner that highlights additional info about this balance report item
 *
 * SOURCE Banner @ squareup/balancereporter/model.proto at 322:3
 */
BalanceReportItemDetail.Banner = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Banner');
fixType(BalanceReportItemDetail.Banner, {
  variant: {
    required: true
  },
  description: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail.Banner);
/**
 * SOURCE Icon @ squareup/balancereporter/model.proto at 323:5
 */
BalanceReportItemDetail.Banner.Icon = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.Banner.Icon').values;
/**
 * Matches the Market banner variant
 *
 * SOURCE Variant @ squareup/balancereporter/model.proto at 329:5
 */
BalanceReportItemDetail.Banner.Variant = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.Banner.Variant').values;
/**
 * SOURCE ExternalLink @ squareup/balancereporter/model.proto at 337:5
 */
BalanceReportItemDetail.Banner.ExternalLink = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Banner.ExternalLink');
fixType(BalanceReportItemDetail.Banner.ExternalLink, {
  url: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail.Banner.ExternalLink);
/**
 * SOURCE Action @ squareup/balancereporter/model.proto at 340:5
 */
BalanceReportItemDetail.Banner.Action = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.Banner.Action');
fixType(BalanceReportItemDetail.Banner.Action, {
  label: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail.Banner.Action);
/**
 * SOURCE DisplayPosition @ squareup/balancereporter/model.proto at 347:5
 */
BalanceReportItemDetail.Banner.DisplayPosition = $root.lookupEnum('squareup.balancereporter.BalanceReportItemDetail.Banner.DisplayPosition').values;
/**
 * SOURCE FindataTransactionInfo @ squareup/balancereporter/model.proto at 374:3
 */
BalanceReportItemDetail.FindataTransactionInfo = $root.lookupType('squareup.balancereporter.BalanceReportItemDetail.FindataTransactionInfo');
fixType(BalanceReportItemDetail.FindataTransactionInfo, {
  findataTransactionId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BalanceReportItemDetail.FindataTransactionInfo);
/**
 * SOURCE BalanceReportItemImage @ squareup/balancereporter/model.proto at 399:1
 */
export const BalanceReportItemImage = $root.lookupType('squareup.balancereporter.BalanceReportItemImage');
fixType(BalanceReportItemImage, {
  imageUrl: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceReportItemImage);
/**
 * SOURCE DecorationIcon @ squareup/balancereporter/model.proto at 400:3
 */
BalanceReportItemImage.DecorationIcon = $root.lookupType('squareup.balancereporter.BalanceReportItemImage.DecorationIcon');
fixType(BalanceReportItemImage.DecorationIcon, {
  icon: {
    required: true
  },
  backgroundColorCode: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BalanceReportItemImage.DecorationIcon);
/**
 * SOURCE Icon @ squareup/balancereporter/model.proto at 401:5
 */
BalanceReportItemImage.DecorationIcon.Icon = $root.lookupEnum('squareup.balancereporter.BalanceReportItemImage.DecorationIcon.Icon').values;
/**
 * SOURCE BalanceReportItemCanonicalCategory @ squareup/balancereporter/model.proto at 424:1
 */
export const BalanceReportItemCanonicalCategory = $root.lookupType('squareup.balancereporter.BalanceReportItemCanonicalCategory');
fixType(BalanceReportItemCanonicalCategory, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceReportItemCanonicalCategory);
/**
 * SOURCE BalanceReportItem @ squareup/balancereporter/model.proto at 431:1
 */
export const BalanceReportItem = $root.lookupType('squareup.balancereporter.BalanceReportItem');
fixType(BalanceReportItem, {
  id: {
    required: true
  },
  latestEventAt: {
    required: true
  },
  state: {
    required: true
  },
  stateCategory: {
    required: true
  },
  typeCategory: {
    required: true
  },
  title: {
    required: true
  },
  description: {
    required: true
  },
  amount: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceReportItem);
/**
 * The reason the event was declined. Only applicable when activity_state = DECLINED
 *
 * SOURCE DeclineDetails @ squareup/balancereporter/model.proto at 473:3
 */
BalanceReportItem.DeclineDetails = $root.lookupType('squareup.balancereporter.BalanceReportItem.DeclineDetails');
fixType(BalanceReportItem.DeclineDetails);
Builder.createAndAttachToType(BalanceReportItem.DeclineDetails);
/**
 * SOURCE DeclineReason @ squareup/balancereporter/model.proto at 474:5
 */
BalanceReportItem.DeclineDetails.DeclineReason = $root.lookupEnum('squareup.balancereporter.BalanceReportItem.DeclineDetails.DeclineReason').values;
/**
 * SOURCE BalanceOverviewLineItem @ squareup/balancereporter/model.proto at 539:1
 */
export const BalanceOverviewLineItem = $root.lookupType('squareup.balancereporter.BalanceOverviewLineItem');
fixType(BalanceOverviewLineItem);
Builder.createAndAttachToType(BalanceOverviewLineItem);
/**
 * SOURCE BalanceOverviewLineItemType @ squareup/balancereporter/model.proto at 540:3
 */
BalanceOverviewLineItem.BalanceOverviewLineItemType = $root.lookupEnum('squareup.balancereporter.BalanceOverviewLineItem.BalanceOverviewLineItemType').values;
/**
 * SOURCE BalanceOverviewTopLevelLineItem @ squareup/balancereporter/model.proto at 603:1
 */
export const BalanceOverviewTopLevelLineItem = $root.lookupType('squareup.balancereporter.BalanceOverviewTopLevelLineItem');
fixType(BalanceOverviewTopLevelLineItem);
Builder.createAndAttachToType(BalanceOverviewTopLevelLineItem);
/**
 * SOURCE BalanceOverviewTopLevelLineItemType @ squareup/balancereporter/model.proto at 604:3
 */
BalanceOverviewTopLevelLineItem.BalanceOverviewTopLevelLineItemType = $root.lookupEnum('squareup.balancereporter.BalanceOverviewTopLevelLineItem.BalanceOverviewTopLevelLineItemType').values;
/**
 * SOURCE BalanceOverview @ squareup/balancereporter/model.proto at 631:1
 */
export const BalanceOverview = $root.lookupType('squareup.balancereporter.BalanceOverview');
fixType(BalanceOverview);
Builder.createAndAttachToType(BalanceOverview);
/**
 * SOURCE ReportType @ squareup/balancereporter/model.proto at 639:1
 */
export const ReportType = $root.lookupEnum('squareup.balancereporter.ReportType').values;
/**
 * SOURCE ReportAccountId @ squareup/balancereporter/model.proto at 648:1
 */
export const ReportAccountId = $root.lookupType('squareup.balancereporter.ReportAccountId');
fixType(ReportAccountId, {
  reportType: {
    required: true
  },
  id: {
    required: true
  }
});
Builder.createAndAttachToType(ReportAccountId);
/**
 * SOURCE CurrencyConversionData @ squareup/balancereporter/model.proto at 654:1
 */
export const CurrencyConversionData = $root.lookupType('squareup.balancereporter.CurrencyConversionData');
fixType(CurrencyConversionData);
Builder.createAndAttachToType(CurrencyConversionData);
/**
 * SOURCE AmountDetails @ squareup/balancereporter/model.proto at 661:1
 */
export const AmountDetails = $root.lookupType('squareup.balancereporter.AmountDetails');
fixType(AmountDetails);
Builder.createAndAttachToType(AmountDetails);
/**
 * SOURCE ReportTypeMetadata @ squareup/balancereporter/model.proto at 667:1
 */
export const ReportTypeMetadata = $root.lookupType('squareup.balancereporter.ReportTypeMetadata');
fixType(ReportTypeMetadata);
Builder.createAndAttachToType(ReportTypeMetadata);
/**
 * SOURCE SquareCardMetadata @ squareup/balancereporter/model.proto at 669:3
 */
ReportTypeMetadata.SquareCardMetadata = $root.lookupType('squareup.balancereporter.ReportTypeMetadata.SquareCardMetadata');
fixType(ReportTypeMetadata.SquareCardMetadata);
Builder.createAndAttachToType(ReportTypeMetadata.SquareCardMetadata);
/**
 * SOURCE CardSpendMerchant @ squareup/balancereporter/model.proto at 670:5
 */
ReportTypeMetadata.SquareCardMetadata.CardSpendMerchant = $root.lookupType('squareup.balancereporter.ReportTypeMetadata.SquareCardMetadata.CardSpendMerchant');
fixType(ReportTypeMetadata.SquareCardMetadata.CardSpendMerchant);
Builder.createAndAttachToType(ReportTypeMetadata.SquareCardMetadata.CardSpendMerchant);